var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse163(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 189,
    viewBox: "0 0 370 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M348.29 168.269C412.843 174.706 318.536 168.269 259.309 168.269C200.082 168.269 0 221.431 0 157.492C0 93.5525 106.907 0 166.133 0C225.36 0 260.388 123.421 348.29 168.269Z",
    fill: "#63DBD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse163);
export default __webpack_public_path__ + "static/media/Ellipse 163.7f1a14de3d360e2a8fa1ccf28fe3aadc.svg";
export { ForwardRef as ReactComponent };